<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{ $t('committees.createCommittee') }}</strong>
            </b-card-header>

            <b-card-body>
                <Form @onSubmit="onSubmit" />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import Form from './components/Form'
import notification, { success, danger } from '@/lib/notification'
import { mapperCommitteesToAPI } from './mappers/mapperCommitteesToAPI'

notification.init()

export default {
    name: 'NewCommittee',
    components: {
        Form,
    },
    methods: {
        redirectToList() {
            this.$router.push({ path: '/v2/administrator/committees/list' })
        },
        onSubmit(form, onReset, isLoading) {
            api.post('/admin/committees', mapperCommitteesToAPI(form))
                .then(() => {
                    onReset()
                    this.notificationRangeCreatedSuccessfully()
                    this.redirectToList()
                })
                .catch(e => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationRangeCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('committees.committee'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
